import axios from "axios";
import {
    USER_addres,
    API_USER_get_user_from_id, API_USER_login, API_USER_get_my_profile, API_USER_registration, API_USER_get_my_diamond, API_USER_get_my_rating,
    API_USER_get_my_role, API_USER_put_my_profile, API_USER_whatLectureNow, API_USER_learnings_myBuyLectures, API_USER_learnings_byLecture, API_USER_learnings_payTask, API_USER_get_my_task,
    API_USER_get_all_user, API_USER_profileData, API_USER_get_id_rating, API_USER_learnings_myTaskMineKlava, API_USER_learnings_TasksMineKlava, API_USER_learnings_payTaskMineKlava,
    API_USER_learnings_doneTaskWeb, API_USER_buyLevel, API_USER_search, API_USER_admin, API_USER_getLeaderboard, API_USER_getLeadersHistory, API_USER_getTop3Leaders, API_USER_getMonthStats,
    API_USER_sprint_current, API_USER_sprint_leaderboard, API_USER_allCourseLeaders,
    API_USER_learnings_doneTaskWebNotPay,API_USER_get_for_id_subscribe_me
} from './API';


export default class UserService {

    // Регистрация
    static async registration(user, printEror) {
        try {
            const response = await axios.post(API_USER_registration, {
                'firstName': user.username,
                'password': user.password,
                'email': user.email
            });

            if (response.data.message === 'Пользователь создан') {
                return true; // Возвращаем true при успешной регистрации
            } else if (response.data.message === 'Аккаунт с таким email зарегистрирован') {
                printEror('Аккаунт с таким email зарегистрирован');
                return false; // Возвращаем false при ошибке
            }
        } catch (error) {
            console.log(error);
            // error.response есть только при ответе сервера. При сетевой
            // ошибке (нет связи, CORS, таймаут) response === undefined —
            // обращение к .status уронило бы приложение.
            if (error.response) {
                if (error.response.status === 401) {
                    printEror(error.response.data?.message || 'Ошибка');
                }
            } else {
                printEror('Не удалось связаться с сервером. Проверьте подключение.');
            }
            return false; // Возвращаем false в случае ошибки
        }
    }

    // логинимся
    static login = async (user, redirect, printEror) => {

        axios.post(API_USER_login, {
            'password': user.password,
            'email': user.email
        })
            .then(function (response) {

                localStorage.setItem('Authorization', response.data.token) // добавляем токен в локал сторедж
                redirect()
                return 'Успех'
            })
            .catch(function (error) {
                console.log(error);
                // error.response отсутствует при сетевой ошибке
                // (нет связи, CORS, таймаут) — тогда .status уронит UI.
                if (error.response) {
                    if (error.response.status === 401) {
                        printEror(error.response.data?.message || 'Неверный логин или пароль')
                    } else {
                        printEror('Ошибка сервера. Попробуйте позже.')
                    }
                } else {
                    printEror('Не удалось связаться с сервером. Проверьте подключение.')
                }
            })
    }

    // логинимся
    static loginReg = async (user) => {
        try {
            const response = await axios.post(API_USER_login, {
                'password': user.password,
                'email': user.email
            });
            localStorage.setItem('Authorization', response.data.token); // добавляем токен в локал сторедж
            return response.data; // Возвращаем данные ответа
        } catch (error) {
            console.log(error);
            throw error; // Пробрасываем ошибку, чтобы ее можно было обработать
        }
    }




    // получить данные моего профиля
    static getMyProfile = async () => {
        const response = await axios.get(API_USER_get_my_profile, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data.data
    }


    // получить данные юзера по id серилизовано
    static async getUserForIdSerialise(idUser) {
        const response = await axios.get(API_USER_get_user_from_id + idUser, {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        })
        return response.data
    }

    // получить мои алмазы
    static async getMyDiamond() {
        const response = await axios.get(API_USER_get_my_diamond, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.count
    }

    // получить мой рейтинг
    static async getMyRating() {
        const response = await axios.get(API_USER_get_my_rating, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data.rating
    }
    // получить мои достижения
    static async getMyAchievs() {
        const response = await axios.get(API_USER_get_my_rating, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data
    }

    // получить чужие данные по таблицу 
    static async getRatingForId(id) {
        const response = await axios.get(API_USER_get_id_rating + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data
    }

    // получить мою роль
    static async getMyRole() {
        const response = await axios.get(API_USER_get_my_role, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data
    }


    // изменить профиль
    static async putMyProfile(get_res, option) {
        const formData = new FormData();
        if (option.photo) { formData.append("photo", option.photo); }
        formData.append("basicCourse", option.basicCourse);
        formData.append("city", option.city);
        formData.append("country", option.country);
        formData.append("firstName", option.firstName);
        formData.append("lang", option.lang);
        formData.append("lastName", option.lastName);
        formData.append("status", option.status);
        await axios.put(API_USER_put_my_profile, formData, {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        })
            .then(function (response) {
                get_res(response.data.message)
            })
    }


    // получить лекцию своего основного курса по JWT
    static async getMyLearning() {
        try {
            const response = await axios.get(API_USER_whatLectureNow, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return response.data.whatLectureNow
        } catch (e) { }
    }

    // получить мои купленные лекции
    static async getMyBuyLectures(course) {
        try {
            const response = await axios.get(API_USER_learnings_myBuyLectures + course, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })

            return response.data.buyLectures
        } catch (e) { }
    }

    // получить мои решенные задачи
    static async getMyAddTasks(course) {
        try {
            const response = await axios.get(API_USER_get_my_task + course, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return response.data.task
        } catch (e) { }
    }


    // Купить лекцию по id
    static async BuyLecture(idLecture, course) {
        // console.log('idLecture = '+idLecture);

        try {
            const formData = new FormData();
            const response = await axios.put(API_USER_learnings_byLecture + idLecture + '/' + course, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            // console.log(response.data);

            return response.data.message
        } catch (e) { }

    }



    // платим за решенную задачу
    static async payTask(idTask, course) {
        try {
            const formData = new FormData();
            const response = await axios.put(API_USER_learnings_payTask + idTask + '/' + course, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            // console.log(response.data.message);

            return response.data.message
        } catch (e) { }

    }

    // получить всех пользователей сериализовано
    static async getAllUser(page) {
        const response = await axios.get(API_USER_get_all_user + page, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }
    // получить всех пользователей сериализовано
    static async getProfileData(id) {
        const response = await axios.get(API_USER_profileData + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }


    // получить список моих задач майнклава
    static async getMyTaskMineKlava() {
        const response = await axios.get(API_USER_learnings_myTaskMineKlava, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }

    // получить список всех заданий по майн клаве без тела
    static async getTasksMineKlava(device) {
        const response = await axios.get(API_USER_learnings_TasksMineKlava + '/' + device, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }


    // прошел задание в Майн Клаве с учетом устройства
    static async postPayTaskMineKlava(idTask, dataTask, device) {
        try {
            const response = await axios.post(API_USER_learnings_payTaskMineKlava, {
                'idTask': idTask,
                'dataTask': dataTask,
                'device': device
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data
        } catch (error) {
            console.log('Ошибка запроса к серверу');
            console.log(error);
            throw error;
        }
    }

    // Проверка на выполнение задания в курсе по вебу
    static async doneTaskWeb(submitSolution, idTaskWrap) {
        const formData = new FormData();
        formData.append("submitSolution", submitSolution);
        formData.append("idTaskWrap", idTaskWrap);


        try {
            const response = await axios.post(API_USER_learnings_doneTaskWeb, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return await response.data.result
        } catch (error) {
            console.log('Ошибка запроса к серверу');
            // console.log(response.data.error);

        }

    }

    // Проверка на выполнение задания в курсе по вебу без оплаты для хелпа
    static async doneTaskWebNotPay(submitSolution, idTaskWrap) {
        const formData = new FormData();
        formData.append("submitSolution", submitSolution);
        formData.append("idTaskWrap", idTaskWrap);


        try {
            const response = await axios.post(API_USER_learnings_doneTaskWebNotPay, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return await response.data.result
        } catch (error) {
            console.log('Ошибка запроса к серверу');
            // console.log(response.data.error);

        }

    }

    // купить уровень
    static async buyLevel() {
        const response = await axios.get(API_USER_buyLevel, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }

    // Поиск пользователей по имени
    static async searchUsers(query) {
        try {
            if (!query || query.trim().length === 0) {
                return { data: [], count: 0, query: '' };
            }

            const response = await axios.get(API_USER_search + encodeURIComponent(query.trim()), {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });

            return response.data;
        } catch (error) {
            console.error('Ошибка поиска пользователей:', error);
            throw error;
        }
    }

    // Получить данные админского дашборда
    static async getAdminDashboard() {
        try {
            const response = await axios.get(API_USER_admin, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения данных дашборда:', error);
            throw error;
        }
    }

    // Получить таблицу лидеров с пагинацией
    static async getLeaderboard(page = 1) {
        try {
            const response = await axios.get(API_USER_getLeaderboard + page, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения таблицы лидеров:', error);
            throw error;
        }
    }

    // Получить историю лидеров прошлых месяцев
    static async getLeadersHistory() {
        try {
            const response = await axios.get(API_USER_getLeadersHistory, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения истории лидеров:', error);
            throw error;
        }
    }

    // Получить топ-3 лидеров текущего месяца
    static async getTop3Leaders() {
        try {
            const response = await axios.get(API_USER_getTop3Leaders, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения топ-3 лидеров:', error);
            throw error;
        }
    }

    // Получить статистику текущего месяца
    static async getMonthStats() {
        try {
            const response = await axios.get(API_USER_getMonthStats, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения статистики месяца:', error);
            throw error;
        }
    }

    // Текущий недельный спринт (период, призы)
    static async getCurrentSprint() {
        try {
            const r = await axios.get(API_USER_sprint_current, {
                headers: { 'Authorization': localStorage.getItem('Authorization') }
            });
            return r.data;
        } catch (e) { return null; }
    }

    // Таблица лидеров недельного спринта
    static async getSprintLeaderboard() {
        try {
            const r = await axios.get(API_USER_sprint_leaderboard, {
                headers: { 'Authorization': localStorage.getItem('Authorization') }
            });
            return r.data;
        } catch (e) { return null; }
    }

    // Лидеры по каждому курсу (для трофеев на профиле)
    static async getAllCourseLeaders() {
        try {
            const r = await axios.get(API_USER_allCourseLeaders, {
                headers: { 'Authorization': localStorage.getItem('Authorization') }
            });
            return r.data;
        } catch (e) { return { leaders: {} }; }
    }

    // Профиль пользователя по id
    static async getUserProfileById(id) {
        try {
            const r = await axios.get(API_USER_get_user_from_id + id, {
                headers: { 'Authorization': localStorage.getItem('Authorization') }
            });
            return r.data;
        } catch (e) { return null; }
    }







    // ✅ Получить статус подписки ученика
    static async checkSubscription() {
        try {

            
            const response = await axios.get(
                API_USER_get_for_id_subscribe_me,
                {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    }
                }
            );

            console.log('✅ Статус подписки:', response.data);

            return {
                hasAccess: response.data.subscription && response.data.history === 'учебный',
                subscription: response.data.subscription,
                history: response.data.history,
                message: response.data.message
            };
        } catch (error) {
            console.error('❌ Ошибка проверки подписки:', error);

            // Если ошибка 401 - токен истек
            if (error.response?.status === 401) {
                this.logout();
                throw new Error('Сессия истекла');
            }

            // По умолчанию нет доступа если ошибка
            return {
                hasAccess: false,
                subscription: false,
                history: null,
                message: 'Ошибка проверки подписки'
            };
        }
    }

    // ──────────────────────────────────────────────────────────
    // OAuth + капча (2026-05-29)
    // ──────────────────────────────────────────────────────────

    /** Проверка нужна ли капча на signup (adaptive — включается при ботнет-атаке). */
    static async isCaptchaRequired() {
        try {
            const r = await axios.get(`${USER_addres}/api/v1/users/captcha/required`);
            return Boolean(r.data?.required);
        } catch {
            return false;
        }
    }

    /** Пара картинок капчи + canvas-задача (см. TripleCaptcha компонент). */
    static async getCaptchaChallengePair() {
        const r = await axios.get(`${USER_addres}/api/v1/users/captcha/challenge-pair`);
        return r.data || {};
    }

    /** POST signup с обязательными captcha-полями (когда isCaptchaRequired=true). */
    static async signupWithCaptcha(payload) {
        const r = await axios.post(`${USER_addres}/api/v1/users/profile/signup`, payload, {
            validateStatus: () => true,
        });
        return { status: r.status, data: r.data };
    }






}














